import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';

import Select from '../common/inputs/select';

const CalculateForm = props => {
  const {
    isDebugMode,
    handleOnChangeForm,
    formData
  } = props;
  if (!isDebugMode) {
    return null;
  }
  return (
    <div className="calculate_form">
      <Select 
        id="debug_mode"
        data-path="debug_mode"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"debug_mode")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="periodAdmin.calculateFormFields.debug_mode"/>}
        options={InterfaceTooling.getSelectArray("selectKeys.periodAdmin.calculationDebugModeSelect","periodAdmin.calculateFormFields.debugModeSelectValues", false)}
      />
      <label className="form_info">
        <strong>
          <FormattedMessage 
            id={"periodAdmin.calculateFormFields.help"}
          />
        </strong>
      </label>
      <label className="form_info">
        <FormattedMessage 
          id={"periodAdmin.calculateFormFields.help2"}
        />
      </label>
    </div>
  );
};

export default CalculateForm;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/calculateForm.jsx